import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useState, useEffect } from "react";
import { useOwnerCurrency } from "@/hooks/useOwnerCurrency";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { BudgetForm } from "./BudgetForm";

export const BudgetSettings = () => {
  const { data: currency } = useOwnerCurrency();
  const [dailyTarget, setDailyTarget] = useState("");
  const [monthlyTarget, setMonthlyTarget] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchBudgetTargets = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          toast.error("Vous devez être connecté pour accéder à cette page");
          return;
        }

        const { data, error } = await supabase
          .from("budget_targets")
          .select("daily_target, monthly_target")
          .eq("owner_id", user.id)
          .maybeSingle();

        if (error) {
          console.error("Erreur lors de la récupération des objectifs:", error);
          toast.error("Erreur lors de la récupération des objectifs");
          return;
        }

        if (data) {
          setDailyTarget(data.daily_target.toString());
          setMonthlyTarget(data.monthly_target.toString());
        } else {
          setDailyTarget("");
          setMonthlyTarget("");
          console.log("Aucun objectif budgétaire trouvé");
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des objectifs:", error);
        toast.error("Erreur lors de la récupération des objectifs");
      }
    };

    fetchBudgetTargets();
  }, []);

  const handleSave = async () => {
    try {
      setIsLoading(true);
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast.error("Vous devez être connecté pour effectuer cette action");
        return;
      }

      const { error } = await supabase
        .from("budget_targets")
        .upsert({
          owner_id: user.id,
          daily_target: parseFloat(dailyTarget) || 0,
          monthly_target: parseFloat(monthlyTarget) || 0,
        });

      if (error) throw error;

      toast.success("Objectifs budgétaires enregistrés");
    } catch (error) {
      console.error("Erreur lors de la sauvegarde des objectifs:", error);
      toast.error("Une erreur est survenue lors de la sauvegarde des objectifs");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Objectifs Budgétaires</CardTitle>
      </CardHeader>
      <CardContent>
        <BudgetForm
          dailyTarget={dailyTarget}
          monthlyTarget={monthlyTarget}
          currency={currency || ""}
          isLoading={isLoading}
          onDailyTargetChange={setDailyTarget}
          onMonthlyTargetChange={setMonthlyTarget}
          onSave={handleSave}
        />
      </CardContent>
    </Card>
  );
};